import { Grid } from '@material-ui/core'
import React from 'react'
import { components } from 'cng-web-lib'
import { useParams } from 'react-router-dom'

import CecDoUomMappingApiUrls from 'src/apiUrls/CecDoUomMappingApiUrls'
import FormProperties from './FormProperties'
import pathMap from 'src/paths/PathMap_CeCAdmin'


const {
  form: { CngViewForm },
  button: { CngSecondaryButton }
} = components

function ViewPage({ showNotification, history }) {
  const { id } = useParams()
  return (
    <>
      <CngViewForm
        fieldLevel="toBeChangedByDeveloperIfWantFieldLevelRestriction"
        showNotification={showNotification}
        history={history}
        bodySection={
          <>
            <FormProperties.Fields
              disabled={true}
              showNotification={showNotification}
              id={id}
            />
            <Grid container spacing={3}>
              <Grid item>
                <CngSecondaryButton
                  onClick={() => { history.push(pathMap.CEC_DO_UOM_MAPPING_LIST_VIEW) }}>
                  {'Back'}
                </CngSecondaryButton>
              </Grid>
            </Grid>

          </>
        }
        formikProps={FormProperties.formikProps}
        toClientDataFormat={FormProperties.toClientDataFormat}
        toServerDataFormat={FormProperties.toServerDataFormat}
        fetch={{
          id: id,
          url: CecDoUomMappingApiUrls.List_DO_UOM_MAPPING
        }}
      />
    </>
  )
}

export default ViewPage
